import { useLayoutEffect, useRef } from 'react';
import { decode } from 'blurhash';
import styles from './BlurHashImage.module.css';

/**
 * BlurHashImage
 * Render một canvas với blurhash đã decode.
 * Dùng làm loading placeholder trước khi krpano sẵn sàng.
 *
 * @param {string}  hash        - Chuỗi blurhash
 * @param {boolean} fadeOut     - true → áp class fadeOut (opacity: 0)
 * @param {number}  [resX=32]   - Độ phân giải canvas ngang (px nội bộ)
 * @param {number}  [resY=32]   - Độ phân giải canvas dọc  (px nội bộ)
 */
function BlurHashImage({ hash, fadeOut = false, resX = 32, resY = 32 }) {
  const canvasRef = useRef(null);

  useLayoutEffect(() => {
    if (!hash || !canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const pixels = decode(hash, resX, resY);
    const imageData = ctx.createImageData(resX, resY);
    imageData.data.set(pixels);
    ctx.putImageData(imageData, 0, 0);
  }, [hash, resX, resY]);

  return (
    <canvas
      ref={canvasRef}
      width={resX}
      height={resY}
      className={`${styles.canvas} ${fadeOut ? styles.fadeOut : ''}`}
      aria-hidden="true"
    />
  );
}

export default BlurHashImage;
